import { lazy } from 'react';
import { Loading } from "../../common/navigation";

export const routes = [
  {
    path: "/views/profile",
    exact: true,
    component: lazy(() => import("./components/Profile")),
    name: "Profile"
  }
];
